import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Container, Form, Button, Spinner, Row, Col } from "react-bootstrap";
import axios from "axiosInstance";
import './css/Inscripciones.css';

function EditarInscripcion() {
  const { id } = useParams();
  const [inscripcion, setInscripcion] = useState(null);
  const [formulario, setFormulario] = useState({
    nombre: '',
    apellidos: '',
    dni: '',
    fecha_nacimiento: '',
    fecha_inscripcion: '',
    nombre_tutor: '',
    apellidos_tutor: '',
    direccion: '',
    telefono_tutor: '',
    sexo: '',
    autoriza_img: 0
  });

  const navegar = useNavigate();
   const navigate = useNavigate();

  useEffect(() => {
    const obtenerInscripcion = async () => {
      try {
        const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/inscripciones/${id}`);
        const datos = respuesta.data.inscripcion;
        setInscripcion(datos);
        setFormulario({
          nombre: datos.nombre || '',
          apellidos: datos.apellidos || '',
          dni: datos.dni || '',
          fecha_nacimiento: datos.fecha_nacimiento || '',
          fecha_inscripcion: datos.fecha_inscripcion || '',
          nombre_tutor: datos.nombre_tutor || '',
          apellidos_tutor: datos.apellidos_tutor || '',
          direccion: datos.direccion || '',
          telefono_tutor: datos.telefono_tutor || '',
          sexo: datos.sexo || '',
          autoriza_img: datos.autoriza_img || 0
        });
      } catch (error) {
        console.error("Error al cargar la inscripción:", error);
      }
    };

    obtenerInscripcion();
  }, [id]);

  const manejarCambio = (e) => {
    const { name, value, type, checked } = e.target;
    setFormulario({
      ...formulario,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value
    });
  };

  const guardarCambios = async (e) => {
    e.preventDefault();
    try {
      await axios.put(process.env.REACT_APP_BACKEND_URL + `/api/inscripciones/${id}`, formulario);
      alert("Inscripción actualizada correctamente");
      navegar('/inscripcionUser');
    } catch (error) {
      console.error("Error al actualizar la inscripción:", error);
    }
  };
   const volver = () => {
    navigate(-1); 
  };

  if (!inscripcion) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="grow" />
        <p>Cargando inscripción...</p>
      </div>
    );
  }

  return (
    
    <Container className="contenedorEventos my-4">
       <Button  className="boton_accion" size="sm" onClick={volver}> ⬅ Volver</Button>
      <h2 className="tituloEvento mb-4">Editar Inscripción: {formulario.nombre} {formulario.apellidos}</h2>
     
      <Form onSubmit={guardarCambios}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="nombre">
              <Form.Label>Nombre</Form.Label>
              <Form.Control type="text" name="nombre" value={formulario.nombre} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="apellidos">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control type="text" name="apellidos" value={formulario.apellidos} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="dni">
              <Form.Label>DNI</Form.Label>
              <Form.Control type="text" name="dni" value={formulario.dni} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="fechaNacimiento">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control type="date" name="fecha_nacimiento" value={formulario.fecha_nacimiento} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="fechaInscripcion">
              <Form.Label>Fecha de Inscripción</Form.Label>
              <Form.Control type="date" name="fecha_inscripcion" value={formulario.fecha_inscripcion} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control type="text" name="direccion" value={formulario.direccion} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="nombreTutor">
              <Form.Label>Nombre del Tutor</Form.Label>
              <Form.Control type="text" name="nombre_tutor" value={formulario.nombre_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="apellidosTutor">
              <Form.Label>Apellidos del Tutor</Form.Label>
              <Form.Control type="text" name="apellidos_tutor" value={formulario.apellidos_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="telefonoTutor">
              <Form.Label>Teléfono del Tutor</Form.Label>
              <Form.Control type="text" name="telefono_tutor" value={formulario.telefono_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="sexo">
              <Form.Label>Sexo</Form.Label>
              <Form.Select name="sexo" value={formulario.sexo} onChange={manejarCambio}>
                <option value="">Seleccione</option>
                <option value="Hombre">Hombre</option>
                <option value="Mujer">Mujer</option>
                <option value="Otro">Otro</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Form.Group controlId="autorizaImg" className="mb-3">
          <Form.Check
            type="checkbox"
            label="Autoriza uso de imágenes"
            name="autoriza_img"
            checked={formulario.autoriza_img === 1}
            onChange={manejarCambio}
          />
        </Form.Group>

        <Button className="boton_accion w-100"  type="submit">Guardar Cambios</Button>
      </Form>
    </Container>
  );
}

export default EditarInscripcion;
